import { z } from 'zod';

export const ScanRequestTypeSchema = z.enum(['single', 'deep', 'rescan']);

export type ScanRequestType = z.infer<typeof ScanRequestTypeSchema>;
